const getHeightOfElement = element => {
  if (element) return element.offsetHeight;
  return 0;
};

export default getHeightOfElement;
